document.addEventListener("DOMContentLoaded", function () {
  const url = window.location.href;

  if (url.includes("car-seat-cover-transition-wrap") && url.includes("view=landing-page-ghl")) {
    
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href");
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: "smooth"
          });
        }
      });
    });

  }
  // function setFirstSectionMargin() {
  // if (window.innerWidth > 949) return;

  // const sidebar = document.querySelector("main-sidebar");
  // const firstSection = document.querySelector('#page-content > [id^="shopify-section-template"]');

  // if (sidebar && firstSection) {
  //   firstSection.style.marginTop = `${sidebar.offsetHeight}px`;
  // }
  // }

// window.addEventListener("load", setFirstSectionMargin);
// window.addEventListener("resize", setFirstSectionMargin);
if (sessionStorage.getItem("om_ann_dismissed")) return;

  const existingAnn = document.querySelector("announcement-bar, .announcement-bar");

  const annHTML = `
    <div class="om-announcement" id="om-announcement">
      <span>
        &#x1F4E6;
        <strong>Free shipping</strong> on orders over $75 &mdash; no code needed!
        Shop our <a href="/collections/all">best sellers</a>
      </span>
      <button class="om-close" aria-label="Close">&times;</button>
    </div>
  `;

  if (existingAnn && existingAnn.children.length === 0) {
    existingAnn.insertAdjacentHTML("afterbegin", annHTML);
  } else {
    const sidebar = document.querySelector("#sidebar, .sidebar-menu");

    if (sidebar) {
      sidebar.insertAdjacentHTML("beforebegin", annHTML);
    } else {
      document.body.insertAdjacentHTML("afterbegin", annHTML);
    }
  }

  const announcement = document.getElementById("om-announcement");

  if (announcement) {
    announcement
      .querySelector(".om-close")
      .addEventListener("click", () => {
        announcement.remove();
        sessionStorage.setItem("om_ann_dismissed", "1");
      });
  }
});